import { useField } from 'formik';
import { useAsync } from 'react-async';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@koob/dates';
import { KoobAlert } from '@koob/ui';
import { getOrganizationCancelConditions } from 'api/node/organization';
import { getOrgFallback } from './orgFallback';

// Read only: the org rules stay the org's, so later changes to them still
// apply. Copying them into the experience would freeze them (KD-3881).
export function OrgFallbackConditions({ currency }) {
  const { t } = useTranslation('experiences', {
    keyPrefix: 'form.cancelConditions.orgFallback',
  });
  const { t: tSummary } = useTranslation('cancellationPolicies', {
    keyPrefix: 'summary',
  });
  const [{ value: ownRules }] = useField('cancelConditions');
  const [{ value: periods }] = useField('periods');
  const [{ value: organizationId }] = useField('organizationId');

  const { data } = useAsync({
    promiseFn: getOrganizationCancelConditions,
    organizationId,
    watch: organizationId,
  });

  const groups = getOrgFallback({ ownRules, periods, orgRules: data?.data });
  if (groups.length === 0) return null;

  return (
    <KoobAlert variant="info" icon="fa-building" title={t('title')}>
      <p>{t('description')}</p>
      {groups.map(({ from, to, rules }) => (
        <div key={from ?? 'all'} className="mt-3">
          {from && (
            <p className="font-medium">
              {formatDate(from, 'MMM DD, YYYY')} –{' '}
              {formatDate(to, 'MMM DD, YYYY')}
            </p>
          )}
          <ul className="list-disc pl-5">
            {rules.map((rule) => (
              <li key={rule.id}>
                {tSummary(
                  rule.isPercent ? 'deductionPercentage' : 'deductionAmount',
                  { ...rule, currency },
                )}{' '}
                ({formatDate(rule.from, 'MMM DD, YYYY')} –{' '}
                {formatDate(rule.to, 'MMM DD, YYYY')})
              </li>
            ))}
          </ul>
        </div>
      ))}
    </KoobAlert>
  );
}
